<div class="d-flex h-100 bg-white position-relative">
  <div class="d-flex container justify-content-center align-items-center h-100">
    <div class="row">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div *ngIf="innerWidth < 768" class="row justify-content-center mb-5">
            <div class="col-6">
              <img
                class="img-fluid"
                src="./../../../../assets/images/logo-alterdata-dark.png"
                alt="page-not-found-404"
              />
            </div>
          </div>

          <div class="row row-gap-5">
            <div class="col-12 col-md-6 text-end align-self-center">
              <img
                class="img-fluid"
                src="./../../../../assets/images/404.png"
                alt="page-not-found-404"
              />
            </div>
            <div
              class="col-12 col-md-6 align-self-center"
              [ngClass]="{
                'text-center': innerWidth < 768
              }"
            >
              <h1 class="text-primary mb-3 fw-bold"><b>OPS!</b></h1>
              <p class="text-secondary fs-5 mb-3">
                Parece que você tentou acessar uma página inexistente.
              </p>
              <p class="text-secondary fs-5 mb-3">
                Verifique o URL e tente novamente.
              </p>
              <p class="text-secondary fs-5">
                Se o problema persistir, retorne à nossa
                <a [routerLink]="['/home']">página inicial.</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="innerWidth > 768"
    class="d-flex align-items-center justify-content-center bg-light position-absolute bottom-0 w-100"
    style="height: 3rem"
  >
    <div class="container text-center">
      <p class="text-secondary mb-0">
        Copyright 1989-{{ anoAtual }} - Alterdata Software - Direitos reservados
        | Versão do sistema: {{ currentApplicationVersion }}
      </p>
    </div>
  </div>
</div>
